import { render, staticRenderFns } from "./ObserverDeclaration.vue?vue&type=template&id=7e25124c&scoped=true"
import script from "./ObserverDeclaration.vue?vue&type=script&lang=js"
export * from "./ObserverDeclaration.vue?vue&type=script&lang=js"
import style0 from "./ObserverDeclaration.vue?vue&type=style&index=0&id=7e25124c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25124c",
  null
  
)

export default component.exports